import moment from "moment";
import "moment/locale/sv";
import {
  RenderPlannerFilters,
  RenderFinalizeProjectsPage,
  RenderReactDropdown,
  RenderImportCustomersPage,
  RenderImportArticlesPage,
  RenderFortnoxImportPage,
  RenderFortnoxInvoiceCreatorPage,
} from "./render_component";

type Scope = {
  RenderPlannerFilters: typeof RenderPlannerFilters;
  RenderFinalizeProjectsPage: typeof RenderFinalizeProjectsPage;
  RenderReactDropdown: typeof RenderReactDropdown;
  RenderImportCustomersPage: typeof RenderImportCustomersPage;
  RenderImportArticlesPage: typeof RenderImportArticlesPage;
  RenderFortnoxImportPage: typeof RenderFortnoxImportPage;
  RenderFortnoxInvoiceCreatorPage: typeof RenderFortnoxInvoiceCreatorPage;
  SetLocale: typeof SetLocale;
  filterJson: string | null;
};

let GlobalScope: Scope = {
  RenderPlannerFilters,
  RenderFinalizeProjectsPage,
  RenderReactDropdown,
  RenderImportCustomersPage,
  RenderImportArticlesPage,
  RenderFortnoxImportPage,
  RenderFortnoxInvoiceCreatorPage,
  SetLocale,
  filterJson: null,
};

export default GlobalScope;

export function CreateGlobalScope() {
  window["MedPlanner"] = GlobalScope;
}

function SetLocale(locale: string) {
  moment.locale(locale);
}
